import { useEffect } from 'react'
import styled from 'styled-components'
import { useInView } from 'framer-motion'

import { breakpoints } from '@/styles'

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    max-width: unset;
    margin: 0 0 36px 0;
  }
`

type VideoSectionProps = {
  videoSrc: string
  videoRef: any
  loop: boolean
}

const VideoSection: React.FC<VideoSectionProps> = ({
  videoSrc,
  videoRef,
  loop
}) => {
  const isInView = useInView(videoRef)

  useEffect(() => {
    if (isInView) {
      videoRef?.current?.play()
    } else {
      videoRef?.current?.pause()
      videoRef.current.currentTime = 0.00000001
    }
  }, [isInView, videoRef])

  return (
    <ImageWrapper>
      <video
        ref={videoRef}
        style={{
          objectFit: 'contain',
          width: '100%'
        }}
        playsInline
        preload="auto"
        autoPlay
        muted
        loop={loop}
      >
        <source src={videoSrc} type="video/mp4" />
      </video>
    </ImageWrapper>
  )
}

export default VideoSection
